import React, { useState } from 'react'
import { DropdownComponent, InputComponent } from '../../core/Forms';
import {useReportStore} from '../../../state/useReportStore';
import { CloseIcon } from '../../../assets/icons';
import { Button, SearchInput } from '../../../components/common';
import { useCustomerSearch } from '../../../hooks';

interface CustomerFilterProps{
  handleOnChange: (e: any) => void;
  formData: any
}


const CustomerReportFilterForm = ( {handleOnChange, formData}: CustomerFilterProps) => {
    const [text, setText] = React.useState('')
    const generateReport = useReportStore( (state) => state.generateReport) 
    const isLoading = useReportStore( (state) => state.isLoading)
    const buttonText = "Download Bank Account"
    const [customerValue, setCustomerValue] = useState("Select a Vendor")

    const { data: customers, isSearching, handleSearch: handleCustomerSearch } = useCustomerSearch()
  return (
    <div>
         <div className='mt-[33px] 280:flex 280:justify-center 360:block'> 
         <SearchInput
              placeholder={"Select InventoryID"}
              displayKey={"invoice Number"}
              isLoading={isSearching}
              value={text}
              clearIcon={CloseIcon}
              data={customers.map((customer:any) => ({
                ...customer,
                display: customer.name
              }))}
               emptyMessage={'This Item is not found'}
               dropdownClassName="w-[280px] md:ml-[2.7em] lg:w-[200px] lg:ml-[7em] xl:w-[200px] xl:ml-[-6em]"
              dropdownStyle={{
                maxHeight: '800px',
                overflowY: 'auto',
              }}
              classNames="280:max-w-[200px]  350:min-w-[350px] md:min-w-full md:max-w-[276px] border border-gray-300 bg-white max-h-[48px] min-h-[48px] placeholder:text-[15.25px]  rounded p-2  focus:outline-none focus:shadow-outline appearance-none focus:ring-0 leading-normal"
            />
          </div>    
    </div>
  )
}

export default CustomerReportFilterForm